import controller from './sidenav.controller';
import template from './sidenav.html';

const sidenavComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default sidenavComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/sidenav/sidenav.component.js
 **/